import { mixpanel } from '@fiverr-private/obs';

export const trackClick = (args: { completionPercentage: number }): void => {
    _track({ type: 'Click', ...args });
};

export const trackImpression = (args: { completionPercentage: number }): void => {
    _track({ type: 'Impression', ...args });
};

const _track = ({
    type,
    completionPercentage,
}: {
    type: 'Click' | 'Impression';
    completionPercentage: number;
}): void => {
    mixpanel.track(`Business Information - Entry Point - ${type}`, {
        'Entry Point Placement': 'Tailored LIHP - JTBD Card',
        'Entry Point State': completionPercentage > 0 ? 'Partial Info' : 'No Info',
        'Business Info Percentage Completed': completionPercentage,
    });
};
